import React, { useState } from "react";
import jsDig from "utils/jsDig";
import BillingDashboardTable from "dashboards/lite/BillingDashboardTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function BillingDashboard(props) {
  console.log(props)
  const billingDimensions = jsDig(["overall", "total"], props.table_data) ? Object.keys(jsDig(["overall", "total"], props.table_data)).sort() : [];

  let mainIcon = require("images/lite/icons/bar-separated.svg");
  mainIcon = <div className="overview-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  const lastMonthDate = new Date();
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  const lastMonthName = lastMonthDate.toLocaleString('default', { month: 'long' });

  const subHeaderOrder = {
    "total": ["Total"],
    "search": ["Google Ads", "Microsoft Ads", "Total"],
    "social": ["Facebook Ads", "TikTok Ads", "Pinterest Ads", "YouTube", "Total"],
    "marketplace": ["Amazon Ads", "Total"]
  }

  return (
    <>
      <div className="lite-dashboard other-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Spend Summary Report</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <BillingDashboardTable
                headerOrder={["total", "search", "social", "marketplace"]}
                subHeaderOrder={subHeaderOrder}
                data={jsDig(["overall"], props.table_data)}
                tableName={`Spend Summary - ${lastMonthName}`}
                dimensions={billingDimensions}
                topSummaryRow={{dimension: "Total", data: jsDig(["top_summary_bar"], props.table_data)}}
                dataPullErrors={props.data_pull_errors}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
